import AdminPage from 'admin/components/AdminPage'
import ConfirmDialog from 'components/ConfirmDialog'
import useAsyncAction from 'hooks/useAsyncAction'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Route, Routes, useNavigate } from 'react-router'
import { firstValueFrom } from 'rxjs'
import { deletePromptCategory, getPromptCategories, reorderPrompts, savePromptCategory } from 'services/compose/assistant/net'
import { message } from 'services/snackbar'
import { PromptCategory } from 'shared/types'
import { StoreThunkDispatch } from 'store/state'
import { CategoryDetails } from './components/CategoryDetails'
import { CategoryList } from './components/CategoryList'

export function WriterConfig() {
  const navigate = useNavigate()
  const dispatch = useDispatch<StoreThunkDispatch>()

  const fetchData = () => {
    return dispatch(getPromptCategories(true))
  }

  const [getCategories, categories, error, loading] = useAsyncAction(fetchData)

  useEffect(() => {
    getCategories()
  }, [getCategories])

  const onEditCategory = (c: PromptCategory) => {
    navigate(`/admin/product/writer/cat/${c.id}`)
  }

  const createNewCategory = (name: string, type: string, visible: boolean) => {
    firstValueFrom(dispatch(savePromptCategory(name, type, visible)))
      .then(() => {
        getCategories()
        dispatch(message('Category created!'))
      })
      .catch(error => {
        console.log('[error]', error)
        dispatch(message(`Error: ${error.message}`))
      })
  }

  const deleteCategory = (c: PromptCategory) => {
    firstValueFrom(dispatch(deletePromptCategory(c.id)))
      .then(() => {
        getCategories()
      })
      .catch(e => {
        console.log('[error]', e)
        dispatch(message(`Error: ${e.message}`))
      })
  }

  useEffect(() => {
    if (error) {
      const msg = (error as any).response?.error.message
      dispatch(message(`Error: ${msg}`))
    }
  }, [dispatch, error])

  const onReorder = (ids: number[]) => {
    firstValueFrom(dispatch(reorderPrompts('category', ids)))
      .then(() => {
        dispatch(message('Categories reordered!'))
      }).catch(e => {
        console.log('[error]', e)
        dispatch(message(`Reordering error: ${e.message}`))
      })
  }

  if (!categories) {
    return null
  }

  return (
    <AdminPage title="AI Writer">
      {loading && <div>Loading...</div>}
      {error && <div>Error: {JSON.stringify(error)}</div>}
      {!loading && !error && (
        <ConfirmDialog message="Delete category?" variant="danger" confirmLabel="Delete">
          {(confirm) => (
            <Routes>
              <Route
                index
                element={(
                  <CategoryList
                    categories={categories}
                    onCreateCategory={createNewCategory}
                    onDeleteCategory={confirm(deleteCategory)}
                    onEditCategory={onEditCategory}
                    onReorder={onReorder}
                  />
                )}
              />
              <Route path="cat/:categoryId" element={<CategoryDetails categories={categories} />} />
            </Routes>
          )}
        </ConfirmDialog>
      )}
    </AdminPage>
  )
}
